var portfolioDelete = {
	title: "Eliminación del portafolio virtual",
	nameInputLabel: "Nombre del portafolio",
	alertHeading: "¿Estás seguro de que deseas eliminar el portafolio virtual?",
	alertBody: "Si es así, haga clic en eliminar. Tenga en cuenta que los portafolios eliminadas no se pueden restaurar",
	confirmBtn: "Ok",
	cancelBtn: "Cancelar"
};
var es = {
	portfolioDelete: portfolioDelete
};

export { es as default, portfolioDelete };
